import React from "react";
import { useNavigate } from "react-router-dom";
import FinancePageHead from "../../components/FinancePageHead";
import FinanceTenantsTab from "../FinanceTenantsTab";
import { ADMIN_FINANCE_PATHS, FINANCE_SECTIONS } from "../../utils/financeTerms";
import "../../assets/css/DigixLeads.css";
import "../../assets/css/FinanceManagement.css";

/** Finance > Receivables: what each client still owes Cloud Office and how late it is. */
function FinanceReceivablesPage() {
  const navigate = useNavigate();
  const openInvoices = (clientId) =>
    navigate(`${ADMIN_FINANCE_PATHS.FinanceInvoices}?client=${clientId}`, { state: { filterClientId: clientId } });

  return (
    <div className="digixleads-container finance-management-page">
      <FinancePageHead section={FINANCE_SECTIONS.receivables} />
      <div className="main-card">
        <div className="finance-management-tab-body">
          <FinanceTenantsTab onOpenInvoices={openInvoices} />
        </div>
      </div>
    </div>
  );
}

export default FinanceReceivablesPage;
